

export class ExportQueuedModel {};